import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { getProductDisplayName } from '../../utils/productNames';
import './AccountPage.css'


const thStyle = {
    padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle',
    fontSize: 11, fontWeight: 'bold', color: '#969696',
    borderBottom: '1px solid #3c3c3c', whiteSpace: 'nowrap',
};
const tdStyle = {
    padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle',
    fontSize: 11, color: '#969696', borderBottom: '1px solid #222', whiteSpace: 'nowrap',
};

const toDateInputValue = (iso) => {
    if (!iso) return '';
    return new Date(iso).toISOString().slice(0, 10);
};

function LicensesTable({entitlements}) {
    return (
        <table style={{borderCollapse: 'collapse'}}>
            <thead>
                <tr>
                    <th style={{...thStyle, width:'20%'}}>License</th>
                    <th style={{...thStyle, width:'20%'}}>Notes</th>
                    <th style={{...thStyle, width:'10%'}}>Max<br/>Activations</th>
                    <th style={{...thStyle, width:'10%'}}>Current<br/>Activations</th>
                    <th style={{...thStyle, width:'10%'}}>Valid Until</th>
                    <th style={{...thStyle, width:'20%'}}>Activation Key</th>
                </tr>
            </thead>
            <tbody>
                {entitlements.length === 0 ? (
                    <tr>
                        <td colSpan={6} style={{...tdStyle, textAlign: 'center', color: '#555'}}>No licenses</td>
                    </tr>
                ) : entitlements.map(entitlement => (
                 <tr key={entitlement.id}>
                    <td style={tdStyle}>
                        <label>{getProductDisplayName(entitlement.product.name)}</label>
                    </td>
                    <td style={tdStyle}>
                        <label>{entitlement.notes ?? ''}</label>
                    </td>
                    <td style={tdStyle}>
                        <label>{entitlement.max_num_activations ?? ''}</label>
                    </td>
                    <td style={tdStyle}>
                        <label>{entitlement.activation_count}</label>
                    </td>
                    <td style={tdStyle}>
                        <label>{toDateInputValue(entitlement.valid_until)}</label>
                    </td>
                    <td style={tdStyle}>
                        <label>
                            {entitlement.activation_keys && entitlement.activation_keys.length > 0
                                ? entitlement.activation_keys.map(k => <div key={k.key} style={{marginBottom: 8}}>{k.key}</div>)
                                : "-"}
                        </label>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
    );
}


function AccountPage() {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword1, setNewPassword1] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [entitlements, setEntitlements] = useState([]);
    const [usergroupid, setUsergroupid] = useState(null);
    const [usergroupname, setUsergroupname] = useState('');
    const [groupEntitlements, setGroupEntitlements] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const user = localStorage.getItem("user");

        axios.get('/api/currentUser/', {
            headers: {'Authorization': `Token ${token}`},
            params: {'user': `${user}`}
        })
        .then(response => {
            if (response.status === 200)
            {
                setFirstName(response.data["firstname"]);
                setLastName(response.data["lastname"]);
                setEmail(response.data["email"]);
                setUsergroupid(response.data["usergroupid"] ?? null);
                setUsergroupname(response.data["usergroupname"] ?? '');
            }
        })
        .catch(error => {
            setFirstName("");
            setLastName("");
            setEmail("");
            setUsergroupid(null);
            setUsergroupname('');
        });
    })

    useEffect(() => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem("user");
        axios.get('/api/entitlements/' + user, {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                console.log(response.data.entitlements);
                setEntitlements(response.data.entitlements);
            }
        })
        .catch(() => setEntitlements([]));
    }, []);

    useEffect(() => {
        if (!usergroupid) {
            setGroupEntitlements([]);
            return;
        }
        const token = localStorage.getItem('token');
        axios.get('/api/groupEntitlements/' + usergroupid, {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                setGroupEntitlements(response.data.entitlements);
            }
        })
        .catch(() => setGroupEntitlements([]));
    }, [usergroupid]);

    const passwordOldChange = (event) => {
        setOldPassword(event.target.value)
    }

    const password1Change = (event) => {
        setNewPassword1(event.target.value)
    }

    const password2Change = (event) => {
        setNewPassword2(event.target.value)
    }

    const changePassword = () => {
        if (newPassword1 !== newPassword2) {
            setPasswordError("Passwords should be the same")
            return;
        }

        const token = localStorage.getItem('token');
        axios.post('/api/changePassword/', {
            email: email,
            oldPassword: oldPassword,
            newPassword: newPassword1,
        }, {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                localStorage.setItem("token", '')
                localStorage.setItem("user", '')
                window.location.reload();
            }
            setNewPassword1('')
            setNewPassword2('')
            setOldPassword('')
        })
        .catch(error => {
            setPasswordError("Could not change password " + error.response.statusText);
            setNewPassword1('')
            setNewPassword2('')
            setOldPassword('')
        });

    }

    return (
      <div style={{ margin: '20px auto', marginTop: 60, width: 'fit-content' }}>
          <hr style={{border:'0.5px solid #3c3c3c', margin: 0}}/>
            <div style={{
                display:'grid',
                gridTemplateColumns: 'auto auto',
                gridTemplateRows: 'auto auto',
                margin: 10,
                color:'#969696'
            }}>
                <label style={{fontSize:12, textAlign:'left'}}>PROFILE</label>
                <div/>
                <div/>
                <div style={{
                    display:'grid',
                    gridTemplateColumns: '150px 200px 150px 200px',
                    gridTemplateRows: '25px 25px 25px 25px 25px',
                    gridRowGap: '10px',
                    gridColumnGap: '10px',
                    fontSize: "12px",
                }}>
                    <label style={{textAlign:'right'}}>Email:</label>
                    <label style={{backgroundColor:'#212121', borderRadius:'2px', alignContent:'center'}}>{email}</label>
                    <label style={{textAlign:'right'}}>Old Password:</label>
                    <input type='password' placeholder="Old Password" style={{backgroundColor:'#212121', border:'0px', borderRadius:'2px', color:'#969696'}} onChange={passwordOldChange} value={oldPassword}/>
                    <label style={{textAlign:'right'}}>First Name:</label>

                    <label style={{backgroundColor:'#212121', borderRadius:'2px', alignContent:'center'}}>{firstName}</label>
                    <label style={{textAlign:'right'}}>New Password:</label>
                    <input type='password' placeholder="New Password" style={{backgroundColor:'#212121', border:'0px',borderRadius:'2px', color:'#969696'}} onChange={password1Change} value={newPassword1}/>
                    <label style={{textAlign:'right'}}>Last Name:</label>
                    <label style={{backgroundColor:'#212121', borderRadius:'2px', alignContent:'center'}}>{lastName}</label>

                    <label style={{textAlign:'right'}}>New Password:</label>
                    <input type='password' placeholder="New Password" style={{backgroundColor:'#212121', border:'0px', borderRadius:'2px', color:'#969696'}} onChange={password2Change} value={newPassword2}/>
                    <div/>
                    <div/>
                    <div/>
                    <button style={{backgroundColor:'black', border:'1px solid #555555', borderRadius:'2px', color:'#969696'}} onClick={changePassword}>Change Password</button>
                    <div/><div/><div/>
                    <label style={{color:'red'}}>{passwordError}</label>
                </div>
            </div>

            <hr style={{border:'0.5px solid #3c3c3c'}}/>
            <label style={{fontSize:12, textAlign:'left', color:'#969696', display:'block'}}>LICENSES</label>
            <div style={{margin: 10}}>
                <LicensesTable entitlements={entitlements}/>
            </div>
            {groupEntitlements.length > 0 && (
                <>
                    <hr style={{border:'0.5px solid #3c3c3c'}}/>
                    <label style={{fontSize:12, textAlign:'left', color:'#969696', display:'block'}}>GROUP LICENSES - {usergroupname.toUpperCase()}</label>
                    <div style={{margin: 10}}>
                        <LicensesTable entitlements={groupEntitlements}/>
                    </div>
                </>
            )}
            <hr style={{border:'0.5px solid #3c3c3c'}}/>
        </div>
    )
}


export default AccountPage
